export default __webpack_public_path__ + "static/media/rtx3060ti.cd268732.jpg";